export default {
  score: 'score',
  artist_sort: 'artist_sort',
  title_sort: 'title_sort',
  released: 'released'
}
